import { type FC, type ReactNode } from "react";
import { Stack } from "@mui/material";

import { AnalyticsIcon } from "@/components/icons";

interface EmptyStateProps {
	readonly children?: ReactNode;
	readonly iconFontSize?: number;
}

export const EmptyState: FC<EmptyStateProps> = ({ children, iconFontSize = 120 }) => {
	return (
		<Stack alignItems="center" gap={3}>
			<AnalyticsIcon
				sx={{
					fontSize: iconFontSize,
				}}
			/>
			{children}
		</Stack>
	);
};
